import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 14.4588L5.25461 16L11.9999 10.554L18.7454 16L20 14.4588L12 8L4 14.4588Z", fill: "white" }));
export default SvgChevron;
